import colors from "core/resources/theme/colors";
import styled from "styled-components";

export const Container = styled.div<any>`
  padding: 0;
  z-index: 999999;
  .select-container > div[class*="control"] {
    background-color: rgb(243 246 249) !important;
    border-color: rgb(243 246 249) !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${(props) =>
      props.isInvalid ? colors.red100 : props.bg || colors.blue100} !important;
  }

  .select-prefix-react-select__menu {
    z-index: 999999;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector,
  .ant-select-selector:hover {
    box-shadow: 0 0 0 2px
      ${(props) => (props.isInvalid ? colors.red : colors.primary)} !important;
    outline-color: ${(props) =>
      props.isInvalid ? colors.red : colors.primary} !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    font-size: 13px !important;
  }

  .ant-select-multiple {
    .ant-select-selection-item {
      border: 1px solid ${colors.primary} !important;
      border-radius: 10px !important;
      font-size: 13px !important;
      height: 30px !important;
      line-height: 30px !important;
    }
  }
`;
